export default __webpack_public_path__ + "static/media/lamp-blue-full.ba071321.svg";